// @flow

import * as React from 'react';
import TextInput from "./TextInput";
import ValidationManager from "../common/ValidationManager";

import type {ComponentMeta} from "../common/CommonTypes";
import type {Action} from "../store/Calculation";
import ReactAI from 'react-appinsights';

type Props = {

    validationManager: ValidationManager,
    
    touched: {[name:string]: boolean},
    error: {[name:string]: ?string},
    
    projectName: string,
    organisationName: string,
    personName: string,

    projectNameMeta: ComponentMeta,
    organisationNameMeta: ComponentMeta,
    personNameMeta: ComponentMeta,

    clearCalculationResult: () => Action,
    changePhaseValues: (phaseNr: number, partialPhaseState: Object) => Action,

    restoreParametersEl: ?Object,

};

class CalculationProjectInfoInput extends React.Component<Props> {
    
    render() {
        
        const onChange = this.handleChange;
        const onBlur = this.handleBlur;
        const onUnmount = this.handleUnmount;
        
        return (
                <div id="project-info" className="project-info input-section">

                <h1 className="input-section-header">Projektinfo</h1>
                
                <div className="input-section-content">
                    <TextInput htmlName="projectName"
                                   onChange={onChange}
                                   onBlur={onBlur}
                                   onUnmount={onUnmount}
                                   labelText="Projektnamn"
                                   phaseNr={0}
                                   value={this.props.projectName}
                                   meta={this.props.projectNameMeta} />
                    
                    <div className="row">
                        <TextInput htmlName="personName"
                                       onChange={onChange}
                                       onBlur={onBlur}
                                       onUnmount={onUnmount}
                                       labelText="Användare"
                                       phaseNr={0}
                                       extraClassFormGroup="col-sm-6"
                                       value={this.props.personName}
                                       meta={this.props.personNameMeta} />
    
                        <TextInput htmlName="organisationName"
                                       onChange={onChange}
                                       onBlur={onBlur}
                                       onUnmount={onUnmount}
                                       labelText="Organisation"
                                       phaseNr={0}
                                       extraClassFormGroup="col-sm-6"
                                       value={this.props.organisationName}
                                       meta={this.props.organisationNameMeta} />
                        
                    </div>
    
                    {this.props.restoreParametersEl}
                </div>
            </div>
        );

    }

    handleChange = (event: SyntheticEvent<>): void => {
        let name = this.getNameFromEvent(event);
        let value = this.getValueFromEvent(event);

        // Dependencies NOT handled for project info
        let newPartialState = {[name]: value};
        
        this.props.changePhaseValues(0, newPartialState);

        // If already touched (in error for example, revalidate)
        if(this.props.touched[name])
            this.validate(name, value);

        this.props.clearCalculationResult();
    };

    handleBlur = (event: SyntheticEvent<>): void => {
        let name = this.getNameFromEvent(event);
        let value = this.getValueFromEvent(event);

        // Update touched status
        let newPartialState = {
            touched: {
                [name]: true
            }
        };
        this.props.changePhaseValues(0, newPartialState);

        // Validate
        this.validate(name, value);
    };

    handleUnmount = (htmlName: string): void => {
        // TODO: Reset touched and error meta data for the unmounted component if needed later
    };

    getNameFromEvent(event: SyntheticEvent<>): string {
        const target = event.currentTarget;
        if(target instanceof HTMLInputElement) {
            return target.name;
        }
        else if(target instanceof HTMLSelectElement) {
            return target.name;
        }
        else {
            throw new Error(`Can't get name from target of type ${typeof target}`);
        }
    }

    getValueFromEvent(event: SyntheticEvent<>): string {
        const target = event.currentTarget;
        if(target instanceof HTMLInputElement) {
            return target.value;
        }
        else {
            throw new Error(`Can't value from target of type ${typeof target}`);
        }
    }

    validate(name: string, value: string) {
        let validationResult = this.props.validationManager.validateText(name, value);
        let newPartialErrorState = this.props.validationManager.createPartialErrorObj(name, validationResult);
        this.props.changePhaseValues(0, {error: newPartialErrorState});
    }



}

export default ReactAI.withTracking(CalculationProjectInfoInput); 



// WEBPACK FOOTER //
// ./src/components/CalculationProjectInfoInput.js